module.exports = __webpack_public_path__ + "static/img/4.aba5d15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/result/4.png
// module id = AfSP
// module chunks = 57